import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import {
  ORG_URL,
  REQUEST_TYPE_URL,
  SLA_URL,
  SLA_BUSINESS_URL,
  SLA_EXIST_URL
} from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import { ThemeProvider } from "../../v2/home/theme/ThemeProvider";
import AddTaskIcon from "@mui/icons-material/AddTask";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useAlert } from "./../../alerts/AlertContext";
import {
  Paper, Typography, RadioGroup, FormControlLabel, Radio,
  Table, TableBody, TableCell, TableHead, TableRow,
  Switch
} from '@mui/material';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { BUSINESS_HOURS_ID, BUSINESS_HOURS, CALENDER_HOURS_ID, CALENDER_HOURS } from "../../../Constants/StatusConstants";
const dayLabels = {
  1: 'Monday', 2: 'Tuesday', 3: 'Wednesday',
  4: 'Thursday', 5: 'Friday', 6: 'Saturday', 7: 'Sunday'
};

function SLADialog({ slaData, callSLAs }) {
  const [open, setOpen] = React.useState(false);
  const [slaName, setSlaName] = useState("");
  const [requestType, setRequestType] = useState("");
  const [requestTypes, setRequestTypes] = useState([]);
  const [organization, setOrganization] = useState("");
  const [organizations, setOrganizations] = useState([]);
  const [desc, setDesc] = useState("");
  const showAlert = useAlert();
  const [mode, setMode] = useState('business'); // 'business' or 'calendar'
  const [enabledDays, setEnabledDays] = useState([1, 2, 3, 4, 5, 6, 7]); // Mon–Fri default
  const [startTime, setStartTime] = useState(new Date('1970-01-01T09:00:00'));
  const [endTime, setEndTime] = useState(new Date('1970-01-01T18:00:00'));
  const [timeZone, setTimeZone] = useState();

  const TIME_ZONES = [
    { value: "Asia/Kolkata", label: "India (Asia/Kolkata) UTC+05:30" },
    { value: "Asia/Dubai", label: "Dubai (Asia/Dubai) UTC+04:00" },
    { value: "Europe/London", label: "United Kingdom (Europe/London)" },
    { value: "America/New_York", label: "US Eastern (New York)" },
    { value: "America/Chicago", label: "US Central (Chicago)" },
    { value: "America/Denver", label: "US Mountain (Denver)" },
    { value: "America/Los_Angeles", label: "US Pacific (Los Angeles)" },
    { value: "America/Phoenix", label: "US Arizona (Phoenix)" },
    { value: "Asia/Singapore", label: "Singapore" },
    { value: "Asia/Tokyo", label: "Japan (Tokyo)" },
    { value: "Australia/Sydney", label: "Australia (Sydney)" }
  ];

  const handleToggleDay = (day) => {
    setEnabledDays(prev =>
      prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
    );
  };


  const [sla, setSla] = useState({
    name: "",
    description: "",
    requestType: {},
    operationalHours: {},
    organization: {},
  });

  useEffect(() => {
    getRequestTypes();
    getOrganizations();
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSLANameChange = (event) => {
    setSlaName(event.target.value);
  };
  const handleTimeZoneChange = (event) => {
    setTimeZone(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDesc(event.target.value);
  };

  const handleRequestTypeChange = (event) => {
    setRequestType(event.target.value);
  };

  const handleOrganizationChange = (event) => {
    setOrganization(event.target.value);
  };

  const getRequestTypes = () => {
    AxiosInstance.get(REQUEST_TYPE_URL).then((response) =>
      setRequestTypes(response.data)
    );
  };

  const getOrganizations = () => {
    AxiosInstance.get(ORG_URL).then((response) =>
      setOrganizations(response.data.data)
    );
  };

  const saveSLA = async () => {
    let formData = new FormData();
    formData.append("orgId", organization);
    formData.append("reqId", requestType);

    AxiosInstance.post(SLA_EXIST_URL, formData).then((response) => {
      if (response.data === true) {
        showAlert("The SLA is already Exist!", "warn");
      } else {
        if (mode === 'business') {
          var slaDTO = {};

          slaDTO.name = slaName;
          slaDTO.description = desc;
          slaDTO.requestTypeId = requestType;
          slaDTO.organizationId = organization;
          slaDTO.operationalHoursId = BUSINESS_HOURS_ID;

          // const schedule = enabledDays.map(day => ({
          //   dayOfWeek: day,
          //   startTime: startTime.toTimeString().slice(0, 5),
          //   endTime: endTime.toTimeString().slice(0, 5)
          // }));

          const schedule = [1, 2, 3, 4, 5, 6, 7].map(day => ({
            timeZone: timeZone,
            dayOfWeek: day,
            workingDay: enabledDays.includes(day),
            startTime: enabledDays.includes(day)
              ? startTime.toTimeString().slice(0, 5)
              : "00:00",
            endTime: enabledDays.includes(day)
              ? endTime.toTimeString().slice(0, 5)
              : "00:00"
          }));


          slaDTO.dayType = mode;
          slaDTO.schedule = schedule;

          AxiosInstance.post(SLA_BUSINESS_URL, slaDTO)
            .then((response) => {
              showAlert("SLA created successfully!", "success");
              callSLAs();
            })
            .catch((error) => {
              showAlert("SLA creation failed!", "error");
              console.error(error);
            });
        } else {

          sla.name = slaName;
          sla.description = desc;
          sla.requestType = { id: requestType };
          sla.organization = { id: organization };
          sla.operationalHours = { id: CALENDER_HOURS_ID };
          AxiosInstance.post(SLA_URL, sla)
            .then((response) => {
              showAlert("SLA created successfully!", "success");
              callSLAs();
            })
            .catch((error) => {
              showAlert("SLA creation failed!", "error");
              console.error(error);
            });

        }
        handleClose();
      }

    });
  };


  return (
    <ThemeProvider>
      <React.Fragment>
        {/* <Button
          variant="outlined"
          onClick={handleClickOpen}
          style={{ float: "right", margin: "5px" }}
        >
          Add SLA
        </Button> */}
        <Tooltip
          title="Add SLA"
          onClick={handleClickOpen}
          style={{ cursor: "pointer", margin: "2px", float: "right" }}
        >
          <IconButton>
            <AddTaskIcon color="primary" />
          </IconButton>
        </Tooltip>
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              saveSLA();
              handleClose();
            },
          }}
        >
          <DialogTitle>Add SLA</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{ "& .MuiTextField-root": { m: 1, width: "50ch" } }}
              noValidate
              autoComplete="off"
            >
              <TextField
                autoFocus
                required
                margin="dense"
                id="rg"
                name="name"
                label="SLA Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={handleSLANameChange}
              />

              <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  Time Zone
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={timeZone}
                  onChange={handleTimeZoneChange}
                  label="Time Zone"
                >
                  <MenuItem value="">
                    {" "}
                    <em>None </em>{" "}
                  </MenuItem>

                  {TIME_ZONES.map((tz) => (
                    <MenuItem key={tz.value} value={tz.value}>
                      {tz.label}
                    </MenuItem>
                  ))}

                </Select>
              </FormControl>

              <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  SLA Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={requestType}
                  onChange={handleRequestTypeChange}
                  label="SLA Type"
                >
                  <MenuItem value="">
                    {" "}
                    <em>None </em>{" "}
                  </MenuItem>
                  {requestTypes.map((rt) => (
                    <MenuItem value={rt.id}>{rt.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
                <InputLabel id="demo-simple-select-standard-label">
                  Organization
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={organization}
                  onChange={handleOrganizationChange}
                  label="Organization"
                >
                  <MenuItem value="">
                    {" "}
                    <em>None </em>{" "}
                  </MenuItem>
                  {organizations.map((org) => (
                    <MenuItem value={org.id}>{org.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Paper sx={{ p: 3, maxWidth: 700, mx: 'auto', mt: 4 }}>
                  <Typography variant="h6" gutterBottom>
                    Configure Working Days
                  </Typography>

                  <RadioGroup
                    row
                    value={mode}
                    onChange={(e) => setMode(e.target.value)}
                    sx={{ mb: 2 }}
                  >
                    <FormControlLabel value="business" control={<Radio />} label="Business Days" />
                    <FormControlLabel value="calendar" control={<Radio />} label="Calendar Days" />
                  </RadioGroup>
                  {mode === 'business' && (
                    <>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Day</TableCell>
                            <TableCell align="center">Enable</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Object.entries(dayLabels).map(([day, name]) => (
                            <TableRow key={day}>
                              <TableCell>{name}</TableCell>
                              <TableCell align="center">
                                <Switch
                                  checked={enabledDays.includes(+day)}
                                  onChange={() => handleToggleDay(+day)}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>

                      <Box mt={3}>
                        <Typography variant="subtitle1">Global Start Time</Typography>
                        <TimePicker
                          value={startTime}
                          onChange={setStartTime}
                          slotProps={{ textField: { size: 'small' } }}
                        />

                        <Typography variant="subtitle1" sx={{ mt: 2 }}>
                          Global End Time
                        </Typography>
                        <TimePicker
                          value={endTime}
                          onChange={setEndTime}
                          slotProps={{ textField: { size: 'small' } }}
                        />
                      </Box>
                    </>
                  )}
                </Paper>
              </LocalizationProvider>
              <TextField
                autoFocus
                id="outlined-multiline-static"
                name="description"
                label="Description"
                placeholder="Enter Description"
                fullWidth
                multiline
                rows={4}
                cols={10}
                onChange={handleDescriptionChange}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </ThemeProvider>
  );
}
export default SLADialog;
